module.exports = __webpack_public_path__ + "img/R-active.b2970ab0.png";